import { type Control, Controller, type FieldValues } from "react-hook-form";
import type { ReactElement } from "react";
import { type FieldPath } from "react-hook-form/dist/types";
import {
  FeedReceptionReasonSelect,
  type IProps as FeedReceptionReasonSelectIProps,
} from "./FeedReceptionReasonSelect";

interface IProps<T extends FieldValues>
  extends Omit<FeedReceptionReasonSelectIProps, "value" | "onChange"> {
  control: Control<T> | undefined;
  name: FieldPath<T>;
}

/**
 * FeedReceptionReasonSelectコンポーネントのコントローラー対応版
 * コントローラーの詳細はReact-Hook-Formのドキュメントを参照
 * https://www.react-hook-form.com/api/usecontroller/controller/
 * @param props
 */
const CFeedReceptionReasonSelect = <T extends FieldValues>(
  props: IProps<T>
): ReactElement => {
  const { name, control, ...selectProps } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => {
        return (
          <FeedReceptionReasonSelect
            {...selectProps}
            value={value}
            onChange={onChange}
          />
        );
      }}
    />
  );
};

export { CFeedReceptionReasonSelect };
